var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEmbedded)?_c('sign-up-wizard',{attrs:{"show":_vm.wizardVisible},on:{"update:show":[function($event){_vm.wizardVisible=$event},_vm.onWizardClose]}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }